module.exports = __webpack_public_path__ + "static/media/favicon-16x16.1fc96e75.png";